let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dFMmS")).then(() => parcelRequire('6MBBj'));